import { models } from '@therms/models'
import Store from 'services/store'


// global singleton so it only runs once
let hasRan = false

export async function runSampleDataLoading() {
  if (hasRan) return

  hasRan = true

  await Store.OrganizationMetadata.update(Store.OrganizationMetadata.getAll()[0].id, { firstLogin: false })


  // **********************************************************************


  const organizationMetadataId = Store.OrganizationMetadata.getAll()[0].id
  const region = Store.Region.getAll()[0]
  const regionMetadataId = Store.Region.getAll()[0].regionMetadataId
  const user = Store.User.getAll()[0]

  const builtInsByName = models.reportType.fixtures.builtInsByName

  async function createLocation(city, state) {
    const location = {
      address: {
        city,
        state,
      },
      name: 'Training Location',
      number: 'T-100',
      settings: {
        accessLog: true,
        bolo: true,
        contacts: true,
        dispatch: true,
        files: true,
        map: true,
        passDown: true,
        postOrders: true,
        reports: true,
        service: true,
        subLocations: true,
        tags: true,
        tasks: true,
      },
    }

    return Store.Location.create(location)
  }

  async function createLocationPassDown(locationId) {
    const passdown = {
      accessLevel: 1,
      active: true,
      body: 'This is a demo Pass Down.\n\nPass Downs are used to hand-off information from one shift to the next. You can optionally set an expiration date on a Pass Down if it is relevant for more than 24hrs.\n\nExamples of Pass Downs would be a change to the Post Orders and you want to make sure your staff read the updated Post Orders so you create a Pass Down under the Location.',
      expireDate: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 12).toISOString(), // 2 weeks from now
      locationId,
    }

    return Store.LocationPassDown.create(passdown)
  }

  async function createLocationPostOrder(locationId) {
    const postOrder = {
      accessLevel: 1,
      body: 'This is a Post Order for "general duties" at this Location.\n\nYou can have multiple sets of Post Orders. You can also attach files to Post Orders for items such as a property map or parking assignment list.',
      files: [],
      locationId,
      title: 'General Duties',
    }

    return Store.LocationPostOrder.create(postOrder)
  }

  async function createLocationContact(locationId) {
    const contact = {
      accessLevel: 1,
      email: 'bob@therms.io',
      locationId,
      name: 'Bob',
      notes: 'THIS IS DEMO CONTENT',
      phone: '888-888-8888',
      primary: false,
      title: 'After Hours Maintenance',
    }

    return Store.LocationContact.create(contact)
  }

  async function createLocationBolo(locationId) {
    const bolo = {
      active: true,
      body: 'This is a BOLO about an aggressive dog that has been seen on this property.\n\nBOLOs are useful for passing information along to security officers where officer safety is important.\n\nA BOLO can also have an expiration date set when it will automatically expire. ',
      expireDate: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 12).toISOString(), // 2 weeks from now
      locationId,
      priority: 3,
      showInPortal: true,
      title: 'Aggressive Pit Bull Dog',
    }

    return Store.LocationBolo.create(bolo)
  }

  async function createLocationSubscriber(locationId, email) {
    const subscriber = {
      email,
      moduleMetadata: { report: true, reportTypeIds: null, locationId },
      locationId,
      report: true,
      reportTypeIds: null,
      moduleName: 'location',
    }

    return Store.Subscriber.create(subscriber)
  }

  async function createPersonRecord() {
    const record = {
      fields: {
        additionalInfo: 'DEMO CONTENT',
        age: 50,
        ageIsApproximate: true,
        alias: 'J-doh',
        criminalRecordAgency: "Sherif's Dept.",
        criminalRecordNumber: 'XREF-123',
        dangerous: true,
        eyes: 'Blue',
        gender: 'Male',
        hair: 'Brown',
        height: "5'5",
        mentalIllness: true,
        name: 'John Doe',
        race: 'Russian or Other East Slavic',
        weight: 180,
      },
      files: ['https://therms-files.s3.amazonaws.com/60ac018804a3092bc096642c.jpeg'],
      primaryImageUrl: 'https://therms-files.s3.amazonaws.com/60ac018804a3092bc096642c.jpeg',
      type: 'person',
    }

    return Store.Record.create(record)
  }

  async function createVehicleRecord() {
    const record2 = {
      fields: {
        additionalInfo: 'DEMO CONTENT',
        color: 'Gray',
        make: 'honda',
        model: 'accord',
        plate: 'ABC123',
        state: 'NY',
        type: 'Car',
        vin: 'vin123abc',
        year: 2001,
      },
      files: ['https://therms-files.s3.amazonaws.com/60ac020fc93a582bcef0da60.jpeg'],
      primaryImageUrl: 'https://therms-files.s3.amazonaws.com/60ac020fc93a582bcef0da60.jpeg',
      type: 'vehicle',
    }

    return Store.Record.create(record2)
  }

  async function createBulletin() {
    const bulletin = {
      body: 'THERMS stands for The Report Management System. \nYou can create: \nReports\nDispatch Service Calls\nLocation Post Orders/BOLOs/Pass Downs \nPerson/Vehicle/Property Records\n....and more\n \n',
      // eslint-ignore-next-line
      html: '<p>THERMS stands for <span style="color: rgb(226,80,65);"><strong>The Report Management System</strong>. </span></p>\n<p><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">You can create: </span></p>\n<ul>\n<li><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">Reports</span></li>\n<li><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">Dispatch Service Calls</span></li>\n<li><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">Location Post Orders/BOLOs/Pass Downs </span></li>\n<li><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">Person/Vehicle/Property Records</span></li>\n<li><span style="color: rgb(248,249,250);background-color: rgb(48,48,48);font-size: 16px;font-family: Lato, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;">....and more</span></li>\n</ul>\n<iframe width="560" height="315" src="https://www.youtube.com/embed/XyfOyJtxbaw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n<p></p>\n',
      title: 'Welcome to THERMS!',
    }

    return Store.Bulletin.create(bulletin)
  }

  async function updateOrganizationMetadataSettings() {
    const organizationMetadata = {
      modules: {
        portal: true,
        record: true,
        report: true,
        region: true,
        location: true,
        bulletin: true,
        dispatch: true,
      },
      settings: {
        module: {
          dispatch: {
            allowedDispatchTypeIds: {
              serviceCall: true,
            },
            dispatchTypeSettings: {
              serviceCall: {
                requireClearedWithReportEntry: true,
              },
            },
          },
        },
      },
    }

    return Store.OrganizationMetadata.update(organizationMetadataId, organizationMetadata)
  }

  async function updateRegionMetadataSettings() {
    const regionMetadata = {
      settings: {
        module: {
          dispatch: {
            clearPendingServiceCallAutomatically: true,
            clearPendingServiceCallAutomaticallyHours: '12',
          },
          report: {
            markReportsInactive: true,
            deleteInactiveReports: true,
            lockReportsOnCompletion: true,
            geolocation: true,
          },
          location: {
            serviceType: true,
            locationGroup: true,
            patrolRoute: true,
          },
        },
      },
    }

    return Store.RegionMetadata.update(regionMetadataId, regionMetadata)
  }

  /**
   * REPORT
   */

  async function activateReportTypes() {
    await Promise.all(
      Object.values(builtInsByName).map((rt) => Store.ReportType.create({ ...rt, id: null, active: true })),
    )
  }

  async function createLocationReport(locationId, personRecordId, vehicleRecordId) {
    const reportType = await Store.ReportType.findOne({ name: 'Location' })

    const report = await Store.Report.create({
      activityTypeIds: [],
      contributorUserIds: [],
      inactive: false,
      locationIds: [locationId],
      locked: false,
      recordIds: [],
      reportEntryCount: 0,
      reportTypeId: reportType.id,
      status: 'inprogress',
      statusCode: -1,
      userIds: [],
    })

    const generalReportEntry = {
      fields: {
        activityTypeIds: [],
        entry:
          'Arrived for duty, all clear and quiet at this time.\n\nDEMO CONTENT - "General" Report Entry.',
        files: [],
        timestamp: new Date().toISOString(),
      },
      reportEntryTypeId: 'builtin:basic',
      reportId: report.id,
    }

    const footPatrolReportEntry = {
      fields: {
        endTime: new Date(new Date().getTime() + 1000 * 60 * 15).toISOString(),
        entry:
          'Foot patrolled the perimeter of the property and checked all gates. No signs of vandalism, trespassing or property damage.\n\nDEMO CONTENT - "Foot Patrol" Report Entry.',
        startTime: new Date(new Date().getTime() + 1000 * 60 * 3).toISOString(),
      },
      reportEntryTypeId: 'builtin:footpatrol',
      reportId: report.id,
    }

    const arrestReportEntry = {
      fields: {
        files: [],
        lawEnforcement: true,
        locationOfArrest: 'Parking lot',
        medical: true,
        medicalReason: 'Subject scraped knee during arrest.',
        methodOfArrest: 'limitedPhysical',
        nameOfArrested: 'John Doe',
        notes:
          'Subject was arrested while standing outside of his vehicle and pulling his pants down and urinating on the side walk while smoking what appeared to be a crack pipe.\n\nSubject (Person) and vehicle attached/linked in Records below for tracking.',
        personsMakingArrest: 'Security Officer Joe',
        reason: 'Trespassing, illegal substance, exposing his genital region in public.',
        recordIds: [personRecordId, vehicleRecordId],
        restraints: true,
        timestamp: new Date(new Date().getTime() + 1000 * 60 * 33).toISOString(),
      },
      reportEntryTypeId: 'builtin:arrest',
      reportId: report.id,
    }

    const observationReportEntry = {
      fields: {
        details: 'Broken windows on the main office, see attached photos.',
        files: [
          'https://therms-files.s3.amazonaws.com/60ac09e904a3092bc096655c.jpg',
          'https://therms-files.s3.amazonaws.com/60ac09e9c93a582bcef0db86.jpeg',
          'https://therms-files.s3.amazonaws.com/60ac09e904a3092bc096655a.jpeg',
        ],
        location: 'Front sidewalk of building',
        timestamp: new Date(new Date().getTime() + 1000 * 60 * 115).toISOString(),
      },
      reportEntryTypeId: 'builtin:observation',
      reportId: report.id,
    }

    await Promise.all(
      [generalReportEntry, footPatrolReportEntry, arrestReportEntry, observationReportEntry].map(
        (re) => Store.ReportEntry.create(re),
      ),
    )

    await Store.Report.updateStatus({
      reportId: report.id,
      status: 'complete',
    })

    await Store.Report.updateStatus({
      reportId: report.id,
      status: 'reopened',
    })
  }

  // **********************************************************************

  const userAccount = await Store.UserAccount.find(user.userAccountId)

  const location = await createLocation(region.address.city, region.address.state)

  createLocationBolo(location.id)
  createLocationContact(location.id)
  createLocationPassDown(location.id)
  createLocationPostOrder(location.id)
  createLocationContact(location.id)
  createLocationSubscriber(location.id, userAccount.email)
  const person = await createPersonRecord()
  const vehicle = await createVehicleRecord()
  createBulletin()
  updateOrganizationMetadataSettings()
  updateRegionMetadataSettings()

  await activateReportTypes()
  await createLocationReport(location.id, person.id, vehicle.id)
}
